import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';
import { GECKO_CONSTS, GeckoToastService, GeckoIcon } from '../../';
import './toast.scss';

class GeckoToast extends Component {
  constructor(props) {
    super(props);

    if (!GeckoToastService.emitter)
      GeckoToastService.emitter = new EventEmitter();

    GeckoToastService.emitter.addListener('update', () => {
      const items = GeckoToastService.items;
      this.setState({ items });
    });
  }

  state = {
    items: GeckoToastService.items,
  };

  removeToast(toast) {
    return new GeckoToastService().remove(toast);
  }

  renderIcon(type) {
    return GECKO_CONSTS.TOAST_STYLES[type].icon;
  }

  renderClasses(type) {
    return GECKO_CONSTS.TOAST_STYLES[type].class;
  }

  renderToast(toast, i) {
    return (
      <div
        role="alert"
        className={this.renderClasses(toast.type)}
        key={i}
        onClick={this.removeToast.bind(this, toast)}
      >
        <span className="toast-icon-container">
          <GeckoIcon icon={this.renderIcon(toast.type)} />
        </span>
        <span className="message">{toast.message}</span>
      </div>
    );
  }

  render() {
    if (this.state.items.length) {
      return (
        <div className="gecko-toasts">
          {this.state.items.map((toast, i) => this.renderToast(toast, i))}
        </div>
      );
    }
    return null;
  }
}

export default GeckoToast;
